/**
 * 이 브라우저에만 남는 설정(저장된 뷰·컬럼 설정·테마).
 *
 * 계정 설정이 아니다 — 창고 PC 와 사무실 PC 에서 보는 칸이 서로 달라도 이상하지 않고,
 * 오히려 한쪽에서 바꾸면 다른 쪽까지 바뀌는 것이 이상하다.
 *
 * 사생활 보호 모드에서는 읽기·쓰기 자체가 예외를 던진다. 설정 하나 때문에 화면이
 * 죽으면 안 되므로 전부 삼키고 기본값으로 간다.
 */
export function readJson<T>(key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(key)
    if (raw === null) return fallback
    return JSON.parse(raw) as T
  } catch {
    return fallback
  }
}

export function writeJson(key: string, value: unknown): void {
  try {
    localStorage.setItem(key, JSON.stringify(value))
  } catch {
    // 저장이 막혀도 이번 세션 동안은 바뀐 채로 쓴다.
  }
}

/**
 * 설정 열쇠는 계정마다 따로 둔다. 창고 PC 한 대를 여러 사람이 번갈아 쓰는데
 * 앞사람이 숨긴 칸이 뒷사람 화면에도 없으면 "왜 안 보이지"가 된다.
 */
export function userKey(base: string, userId: number | null | undefined): string {
  return `${base}:${userId ?? "anon"}`
}
